class CartSlider extends HTMLElement {
  constructor() {
    super();
    const cartSlider = this.querySelector('.cart-upsell-slider');    
    let cartUpsellSlider = new Swiper(cartSlider, {
      slidesPerView: 1,
      calculateHeight: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      spaceBetween: 2,  
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
        750: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 2,
        },
      },
    });
  }

  connectedCallback() {    
    
  }  
}
customElements.define('cart-slider', CartSlider);


class CartCarousel extends HTMLElement {
  constructor() {
    super();
    const cartCarouselEle = this.querySelector(".cart__feature-slider");
    const cartCarousel = new Swiper(cartCarouselEle, {
      slidesPerView: 1,   
      loop: true,   
      autoplay: {
          delay: 5000,
          disableOnInteraction: false,
      },     
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
    });
  }
}
customElements.define('cart-carousel', CartCarousel);

document.addEventListener('DOMContentLoaded', function() {
  var swiper = new Swiper(".review-slider", {
    spaceBetween: 40,
    slidesPerView: 1,
    loop: true,
    autoplay: {
        delay: 7000,
        disableOnInteraction: false,
    },
    // freeMode: true,        
    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },        
  });
  
  const thumbnailSlider = new Swiper(".product-thumbnail-slider", {
    slidesPerView: 5,
    spaceBetween: 10,
    autoHeight:true,
    watchSlidesProgress: true,
    direction: "vertical",
    navigation: {
      nextEl: ".thumbnail-button-next", 
      prevEl: ".thumbnail-button-prev", 
    },
      breakpoints: {
        0:{
          slidesPerView: 4,
            spaceBetween: 10,
        },
          1200: {
            slidesPerView:5,
            spaceBetween: 10,
          }
      }
    
  });
  
  const mainSlider = new Swiper(".main-product-slider", {
    slidesPerView: 1,
    autoHeight: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: thumbnailSlider, // Link to the thumbnail slider
    },
  });

  // document.querySelector('.thumbnail-button-next').addEventListener('click', () => {
  //   mainSlider.slideNext();
  // });

  // document.querySelector('.thumbnail-button-prev').addEventListener('click', () => {
  //   mainSlider.slidePrev();
  // });
  
  
  // const mainSlider = new Swiper(".main-product-slider", {
  //     slidesPerView: 1,       
      
  //     pagination: {
  //         el: ".swiper-pagination",
  //         type: "fraction",
  //     },       
  //     navigation: {
  //         nextEl: ".swiper-button-next",
  //         prevEl: ".swiper-button-prev",
  //     },
  // });

  const iconTextSlider = new Swiper("#icon__text-slider", {
      slidesPerView: 1,    
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      }, 
      autoplay: {
        delay: 7000,
        disableOnInteraction: false,
      },
  });
});

document.addEventListener('recommend-slider', () => {
  const paiEle = document.querySelector('.pair-products');
  
  let pairSlider = new Swiper(paiEle,
    {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
          delay: 7000,
          disableOnInteraction: false,
      },
    //   navigation: {
    //     nextEl: ".swiper-button-next",
    //     prevEl: ".swiper-button-prev",
    //   },
      slidesPerView: 1.6,
      spaceBetween: 15,
      breakpoints: {
        1000: {
          slidesPerView: 2.6,
          spaceBetween: 15
        }
      }
    }
  );
});